import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../../groupportal-base/groupportal-base.component";
import {
	AcepSSOService,
	GlobalDomOpsService,
	GlobalDataOpsService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../../shared/models/chapter-details";
import { Observable, Observer, Subject, Subscription, of } from "rxjs";
import { group } from "@angular/animations";
import { Group, GroupInfo } from "../../../../shared/models/group-portal-data.models";

@Component({
	selector: 'group-info-dashboard',
	templateUrl: './group-info-dashboard.component.html'
})

export class GroupInfoDashboardComponent extends MemberappBaseComponent {
	@Input() groupList: any;
	@Input() groupInfoDoneProcessing: boolean;
	selectedGroup: Group;
	// constructor(
	//   private process: DashboardService,
	// ) {

	//   this.subscription = this.process.getHeader().subscribe(header => { this.header = header; });
	//   this.process.getOrderAmount().subscribe(orderAmount => { this.orderAmount = orderAmount; });
	//   this.process.getOrderNumber().subscribe(orderNumber => { this.orderNumber = orderNumber; });
	// }

	initSubscriptions() {
		// this.groupPortalDataService.getGroupInfo().subscribe(groupInfo => {this.groupList = groupInfo});
		// this.groupPortalDataService.getSelectedGroup().subscribe(selectedGroup => {this.selectedGroup = selectedGroup});
	}
	ngOnInit() {
		// let groupNumber = this.groupPortalDataService.groupList.groupNumber;

		// if (groupNumber) {
		// 	this.groupPortalDataService.GetSelectedGroupInfo(this.groupPortalDataService.groupList.groupNumber);
		// }
		//this.dashboardService.callGroupAPIs();
	}
}